
/**
 * 간단 성공 응답
 */
export type MarkLectureAsCompleted200 = {
  /** 성공 여부 */
  success: boolean;
};
